import APIService from 'services/APIService'

const api = APIService()

export const listMyCertifications = () => api.get('/me/certifications')

export const createMyCertification = (payload) =>
  api.post('/me/certifications', payload)

export const updateMyCertification = (id, payload) =>
  api.patch(`/me/certifications/${id}`, payload)

export const deleteMyCertification = (id) =>
  api.delete(`/me/certifications/${id}`)

export const downloadMyCertificationsCsv = () =>
  api.get('/me/certifications/export.csv', { responseType: 'blob' })
